import React from 'react';
import ListStyleOne from '../../components/list-style/one';
import HomeContentSection from '../Home/HomeContentSection';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {colors} from '../../style/constants';
import Pricing from './Pricing';

const useStyles = makeStyles(() => ({
  catchphrase: {
    background: colors.LIGHT_GREY,
    "& a": {
      color: colors.TURQUOISE,
      "&:hover": {
        color: colors.LIGHT_BLUE
      }
    }
  },
  carousel: {
    paddingTop: 0,
  },
}));

const VirtualReception = (props) => {
  const classes = useStyles();
  return (
    <>
      <section id='touch-projects-types'>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[0]} virutalReception/>
        <ListStyleOne lang={props.lang} align='right' items={props.types.edges[1]} virutalReception/>
        <ListStyleOne lang={props.lang} align='left' items={props.types.edges[2]} virutalReception/>
        <ListStyleOne lang={props.lang} align='right' items={props.types.edges[3]} virutalReception/>
      </section>
      <section className={classes.catchphrase + " clipped"}>
        <Container className={classes.container}>
          <h2>
            {props.lang === "en-CA" ? (
              <>
                A reception solution designed to integrate seamlessly with your{" "}
                <a href="/software">digital signage</a>.
              </>
            ) : (
              <>
                Une solution d’accueil conçue pour s’intégrer parfaitement à votre{" "}
                <a href="/logiciel">affichage dynamique</a>.
              </>
            )}
          </h2>
        </Container>
      </section>
      <Pricing lang={props.lang}/>
      <HomeContentSection lang={props.lang}/>
    </>
  );
}
  
export default VirtualReception;